import { getFirestore, deleteDoc, doc, collection, query, where, getDocs } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

// Function to delete an MPS Business Profile and related records
const deleteMPSBusinessProfile = async (userId) => {
    try {
        if (!userId) {
            throw new Error("User ID is required to delete the business profile.");
        }

        // Delete the MPS_BusinessProfiles document
        await deleteDoc(doc(db, "MPS_BusinessProfiles", userId));

        // Delete the user document
        await deleteDoc(doc(db, "users", userId));

        // Delete all records in the mpsEventRegistration collection where userId matches
        const eventRegQuery = query(
            collection(db, "mpsEventRegistration"),
            where("userId", "==", userId)
        );
        const eventRegSnapshot = await getDocs(eventRegQuery);

        const batchDeletes = [];
        eventRegSnapshot.forEach((doc) => {
            batchDeletes.push(deleteDoc(doc.ref));
        });
        await Promise.all(batchDeletes);

        return { success: true, message: "Business profile and related records deleted successfully." };
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export { deleteMPSBusinessProfile };